import Image from 'next/image';
import { m } from 'framer-motion';

import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { useGetWorkExperience } from 'src/api/experience';

import { varFade, MotionViewport } from 'src/components/animate';

import HomeExperience from './HomeExperience';
import HomeExperienceSkeleton from './HomeExperienceSkeleton';

export default function HomeExperienceStats() {
  const { experiencedata, experiencedataLoading } = useGetWorkExperience();

  return (
    <Container component={MotionViewport}>
      {/* Section Header */}
      <Stack
        spacing={3}
        sx={{
          textAlign: 'center',
          mt: { xs: 6, md: 10 },
          mb: { xs: 5, md: 10 },
        }}
      >
        <m.div variants={varFade().inUp}>
          <Typography
            component="div"
            variant="overline"
            sx={{ letterSpacing: 1.2, color: 'text.disabled' }}
          >
            Experience Snapshot
          </Typography>
        </m.div>

        <m.div variants={varFade().inUp}>
          <Typography variant="h3">Professional Journey</Typography>
        </m.div>

        <m.div variants={varFade().inDown}>
          <Typography
            variant="subtitle2"
            sx={{
              color: 'text.secondary',
              maxWidth: 800,
              mx: 'auto',
            }}
          >
            Over the years, I’ve worked across diverse products and teams, contributing to scalable
            systems, user-focused interfaces, and measurable business outcomes. These highlights
            reflect the scope and impact of my professional experience.
          </Typography>
        </m.div>
      </Stack>

      {/* Metrics Grid */}
      <Grid container spacing={3} sx={{ mb: { xs: 5, md: 10 } }}>
        {experiencedataLoading
          ? renderSkeleton
          : experiencedata?.map((workdata, index) => (
              <Grid key={index} xs={12} sm={6} md={3}>
                <HomeExperience
                  title={workdata?.title}
                  total={workdata?.total}
                  color={workdata?.color}
                  icon={
                    <Image
                      alt={workdata?.title || 'Metric icon'}
                      src={`/assets/icons/glass/${workdata?.icon || 'default-icon'}.png`}
                      width={48}
                      height={48}
                    />
                  }
                />
              </Grid>
            ))}
      </Grid>
    </Container>
  );
}

const renderSkeleton = (
  <Grid container spacing={3}>
    {[...Array(4)].map((_, index) => (
      <Grid key={index} xs={12} sm={6} md={3}>
        <HomeExperienceSkeleton />
      </Grid>
    ))}
  </Grid>
);
